import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { Trans } from "react-i18next";

class OtherHome extends Component {
  render() {
    return (
      <Container>
        <div className="services-content row">
          <div className="col-9">
            <h1>Necesitamos contenido</h1>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>

          <img className="col-3" src="other_home.png" />
        </div>
      </Container>
    );
  }
}

export default OtherHome;
